export const formatDate = (date: string) => {
    try {
        return new Date(date).toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
        });
    } catch (error) {
        return new Date().toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
        });
    }
};

export const formatDateTime = (date: string) => {
    try {
        const dateObj = new Date(date);
        return dateObj.toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
        }) + " at " + dateObj.toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
        });
    } catch (error) {
        const fallbackDate = new Date();
        return fallbackDate.toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
        }) + " at " + fallbackDate.toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
        });
    }
};